export default (fractionStr => {
  const fractionStrRegex = /^[0-9]+\/[1-9][0-9]*$/;
  if (fractionStr && fractionStrRegex.test(fractionStr)) {
    const parts = fractionStr.split('/');
    const numerator = parseInt(parts[0]);
    const denominator = parseInt(parts[1]);
    return numerator / denominator;
  }
  return 1;
});
//# sourceMappingURL=index.js.map